import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

import "./JobCategory.css";

const url = process.env.REACT_APP_BACKEND_URL;

const JobCategory = () => {
  const [data, setData] = useState({
    category_name: "",
    description: ""
  });

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  const onChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!data.category_name) {
      toast.error("Category name required");
      return;
    }

    try {
      setSubmitting(true);

      const res = await axios.post(`${url}/api/jobcategory`, data);

      if (res.data.success) {
        toast.success("Category created");
        navigate("/ViewJobcategory");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">Add Job Category</h2>
        <div className="header">
          <button
            onClick={() => navigate("/ViewJobcategory")}
            className="add-button"
          >
            <Plus size={16} /> View Categories
          </button>
        </div>
        <form className="country-form" onSubmit={submit}>
          <div className="form-field filled">
            <input
              type="text"
              name="category_name"
              value={data.category_name}
              onChange={onChange}
              required
            />
            <label>Category Name</label>
          </div>
          <div className="form-field filled">
            <textarea
              name="description"
              value={data.description}
              onChange={onChange}
              rows="4"
            />
            <label>Description</label>
          </div>
          <button className="submit-btn" disabled={submitting}>
            {submitting ? "Saving..." : "Add Category"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default JobCategory;